var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import cx from 'classnames';
import styles from './Dialog.css';
import Events from 'fk-cp-shared/utils/utils';
import RippleMixin from 'fk-cp-shared/mixins/RippleMixin.js';
import { formatMessage } from '../../../utils/i18n';
import { resetBodyOverflow } from 'fk-cp-common-components/utils/domUtils';
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this.show = function () {
            _this.setState({ show: true });
        };
        _this.hide = function () {
            _this.setState({ show: false });
            resetBodyOverflow();
        };
        _this.state = {
            show: false,
            buttons: [
                { text: formatMessage({ id: 'cancel' }), onClick: _this.hide },
                { text: formatMessage({ id: 'ok' }), onClick: _this.hide }
            ]
        };
        _this.handleOverlayClick = _this.handleOverlayClick.bind(_this);
        _this._hashChange = _this._hashChange.bind(_this);
        return _this;
    }
    Dialog.prototype.componentDidMount = function () {
        if (this.props.actions.buttons) {
            this.setState({
                buttons: this.props.actions.buttons
            });
        }
    };
    Dialog.prototype.componentWillUnmount = function () {
        resetBodyOverflow();
    };
    Dialog.prototype.UNSAFE_componentWillReceiveProps = function (nextprops) {
        if (nextprops.actions.buttons) {
            this.setState({
                buttons: nextprops.actions.buttons
            });
        }
        if (nextprops.show !== this.props.show) {
            this.setState({ show: nextprops.show });
        }
    };
    Dialog.prototype.componentDidUpdate = function () {
        var events = new Events();
        if (this.state.show && !this.props.noHashRequired) {
            location.hash = 'dialogBoxOpen';
            events.addEvent(window, 'hashchange', this._hashChange);
        }
        else {
            events.removeEvent(window, 'hashchange', this._hashChange);
        }
    };
    Dialog.prototype.handleOverlayClick = function (e) {
        if (this.props.overlayClickDisabled) {
            return;
        }
        if (e.target === this.overlay) {
            resetBodyOverflow();
            var overlayActions = this.props.actions.overlay;
            if (overlayActions && overlayActions.onClick) {
                overlayActions.onClick.call(this, e);
            }
            else {
                this.hide();
            }
        }
    };
    Dialog.prototype._hashChange = function () {
        if (location.hash === '') {
            this.hide();
        }
    };
    Dialog.prototype.render = function () {
        var _this = this;
        var contentClass = {}, overlayClass = {};
        overlayClass[styles['overlay']] = true;
        overlayClass[styles['easein']] = true;
        contentClass[styles['contentDialog']] = true;
        contentClass[styles['content-top-align']] = this.props.isTopAlign;
        document.body.style.overflow = this.state.show ? 'hidden' : 'auto';
        var textStyle = this.props.textStyle || {};
        if (this.state.show) {
            return (<div className={styles['fk-dialog']} key="dialog">
					<div className={cx(overlayClass)} ref={function (e) { return (_this.overlay = e); }} onClick={this.handleOverlayClick} data-test-id="dialog-container">
						<div className={cx(contentClass)} data-test-id="dialog-content">
							{this.props.title ? <h3 className={styles['title']}>{this.props.title}</h3> : null}
							{this.props.message && <div className={styles['message']}>{this.props.message}</div>}
							<div className={styles['children']}>{this.props.children}</div>
							{this.state.buttons.length > 0 && (<div className={cx(styles['buttonsDialog'], this.props.buttonClass ? this.props.buttonClass : '')}>
									{this.state.buttons.map(function (action, k) {
                var clickHandler = (action.onClick && _this.clickHandler.bind(_this, action.onClick)) ||
                    _this.clickHandler.bind(_this, _this.hide);
                var btnClass = {};
                btnClass[styles['actionDialog']] = true;
                btnClass[styles['blue']] =
                    action.blueTextColor !== undefined ? action.blueTextColor : true;
                return (<button key={k} data-test-id={"dialog-" + k + "-button"} style={textStyle} className={cx(btnClass)} onClick={clickHandler}>
												{action.text}
											</button>);
            }, this)}
								</div>)}
						</div>
					</div>
				</div>);
        }
        return null;
    };
    Dialog.prototype.clickHandler = function (action, e) {
        e.stopPropagation();
        RippleMixin.createRipple(e, e.currentTarget, styles['ink'], styles['animate']);
        action();
    };
    return Dialog;
}(React.Component));
export default Dialog;
